__turbopack_context__.v({
  "benefitCard": "page-module-scss-module__J9v3SG__benefitCard",
  "benefitIcon": "page-module-scss-module__J9v3SG__benefitIcon",
  "benefits": "page-module-scss-module__J9v3SG__benefits",
  "benefitsGrid": "page-module-scss-module__J9v3SG__benefitsGrid",
  "benefitsImageWrap": "page-module-scss-module__J9v3SG__benefitsImageWrap",
  "benefitsInner": "page-module-scss-module__J9v3SG__benefitsInner",
  "benefitsOverlay": "page-module-scss-module__J9v3SG__benefitsOverlay",
  "cta": "page-module-scss-module__J9v3SG__cta",
  "ctaBtn": "page-module-scss-module__J9v3SG__ctaBtn",
  "ctaBtnOutline": "page-module-scss-module__J9v3SG__ctaBtnOutline",
  "ctaButtons": "page-module-scss-module__J9v3SG__ctaButtons",
  "ctaContent": "page-module-scss-module__J9v3SG__ctaContent",
  "ctaNote": "page-module-scss-module__J9v3SG__ctaNote",
  "ctaSub": "page-module-scss-module__J9v3SG__ctaSub",
  "ctaTitle": "page-module-scss-module__J9v3SG__ctaTitle",
  "hero": "page-module-scss-module__J9v3SG__hero",
  "heroContent": "page-module-scss-module__J9v3SG__heroContent",
  "heroCta": "page-module-scss-module__J9v3SG__heroCta",
  "heroImageWrap": "page-module-scss-module__J9v3SG__heroImageWrap",
  "heroOverlay": "page-module-scss-module__J9v3SG__heroOverlay",
  "heroSub": "page-module-scss-module__J9v3SG__heroSub",
  "heroTitle": "page-module-scss-module__J9v3SG__heroTitle",
  "heroWave": "page-module-scss-module__J9v3SG__heroWave",
  "howItWorks": "page-module-scss-module__J9v3SG__howItWorks",
  "intro": "page-module-scss-module__J9v3SG__intro",
  "introContent": "page-module-scss-module__J9v3SG__introContent",
  "introLead": "page-module-scss-module__J9v3SG__introLead",
  "pricing": "page-module-scss-module__J9v3SG__pricing",
  "pricingAmount": "page-module-scss-module__J9v3SG__pricingAmount",
  "pricingAmountRow": "page-module-scss-module__J9v3SG__pricingAmountRow",
  "pricingContent": "page-module-scss-module__J9v3SG__pricingContent",
  "pricingCta": "page-module-scss-module__J9v3SG__pricingCta",
  "pricingCtaDetail": "page-module-scss-module__J9v3SG__pricingCtaDetail",
  "pricingCtaLink": "page-module-scss-module__J9v3SG__pricingCtaLink",
  "pricingFrom": "page-module-scss-module__J9v3SG__pricingFrom",
  "pricingGrid": "page-module-scss-module__J9v3SG__pricingGrid",
  "pricingHighlight": "page-module-scss-module__J9v3SG__pricingHighlight",
  "pricingPer": "page-module-scss-module__J9v3SG__pricingPer",
  "pricingPrice": "page-module-scss-module__J9v3SG__pricingPrice",
  "pricingVideo": "page-module-scss-module__J9v3SG__pricingVideo",
  "resell": "page-module-scss-module__J9v3SG__resell",
  "resellContent": "page-module-scss-module__J9v3SG__resellContent",
  "sectionTitle": "page-module-scss-module__J9v3SG__sectionTitle",
  "sectionTitleDark": "page-module-scss-module__J9v3SG__sectionTitleDark",
  "step": "page-module-scss-module__J9v3SG__step",
  "stepNumber": "page-module-scss-module__J9v3SG__stepNumber",
  "stepsGrid": "page-module-scss-module__J9v3SG__stepsGrid",
});
